export const APP_USER_ROLES = ['User', 'Steward', 'KUD', 'PUSKUD'];

const normalizeRoleName = (role) => role === 'RP' ? 'KUD' : role;

const readDeclaredRoles = (user) => {
  if (Array.isArray(user?.roles)) return user.roles;

  if (typeof user?.roles === 'string') {
    try {
      const parsed = JSON.parse(user.roles);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  }

  return [];
};

// `roles` is the current membership source. Legacy `role` is only used for
// pre-multi-role records whose roles field is absent or empty. `activeRole`
// controls the selected App workspace and must never create a membership.
export const normalizeOwnedUserRoles = (user, allowedRoles = APP_USER_ROLES) => {
  const declaredRoles = readDeclaredRoles(user);
  const sourceRoles = declaredRoles.length > 0
    ? declaredRoles
    : [user?.role].filter(Boolean);
  const normalized = new Set(
    sourceRoles
      .map(normalizeRoleName)
      .filter((role) => allowedRoles.includes(role))
  );

  normalized.add('User');
  return allowedRoles.filter((role) => normalized.has(role));
};
